<script>
  import axios from "axios";
  import vue from "vue";

  export default {
    name: 'BlogLanding',
    data() {

      return {
        all_results: [],
        filtered_results: [],
        results: [],

        loading: true,

        page: 1,

        num_results_per_page: 9,
        num_results_showing: 0,

        filterYear: null,
        filterMonth: null,

        sortDirection: "DESC",

      };
    },

    props: {
      dataUrl: String
    },


    mounted() {
      this.loading = true;
     
      axios.get(`${this.dataUrl}`).then((response) => {

        const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

        var _this = this;

        response.data.forEach(function (card) {

          card.OriginalDate = card.Date;

          var date  = new Date(card.Date);
          card.Date = date.toISOString().split("T")[0].split("-");
          card.Date = monthNames[date.getMonth()] + " " + parseInt(card.Date[2]) + `, ${card.Date[0]}`;

          _this.all_results.push(card);

        });

        this.loading = false;

        this.filterAndSort();

      });

    },

    methods: {
      clearFilters(event) {

        event.preventDefault();
        this.filterYear = null;
        this.filterMonth = null;
        

        (document.getElementById("filterYear") || {}).selectedIndex = 0;
        (document.getElementById("filterMonth") || {}).selectedIndex = 0;

        this.filterAndSort();

      },

      filterAndSort() {

        this.filterYear = (document.getElementById("filterYear") || {}).value || null;

        if (!((document.getElementById("filterYear") || {}).value)) {

          (document.getElementById("filterMonth") || {}).selectedIndex = 0;

          this.filterMonth = null;

        } else {

          this.filterMonth = (document.getElementById("filterMonth") || {}).value;

        }

        this.filterBy();
        this.sortBy();

        this.results = this.results.slice(0, (this.page * this.num_results_per_page));

        this.num_results_showing = Math.min(this.results.length, (this.page * this.num_results_per_page));

      },

      filterBy: function () {

        var results = this.all_results.map((x) => x);

        if (this.filterMonth && !this.filterYear) {

          this.filtered_results = results;
          return;

        }

        if (this.filterYear && !this.filterMonth) {

          var filtered = [];

          results.forEach(function (card) {

            var date  = new Date(card.OriginalDate);
            date      = date.toISOString().split("T")[0].split("-");
            var year  = date[0];

            if (year == (document.getElementById("filterYear") || {}).value) {

              filtered.push(card);

            }

          });

          this.filtered_results = filtered;
          return;

        }

        if (this.filterYear && this.filterMonth) {

          var filtered = [];

          results.forEach(function (card) {

            var date  = new Date(card.OriginalDate);
            date      = date.toISOString().split("T")[0].split("-");
            var month = date[1];
            var year  = date[0];

            if ((year == (document.getElementById("filterYear") || {}).value) &&
                (month == (document.getElementById("filterMonth") || {}).value)
            ) {

              filtered.push(card);

            }

          });

          this.filtered_results = filtered;
          return;

        }

        this.filtered_results = results;

      },

      loadMore: function () {

          this.page++;

          this.filterAndSort();
          this.$nextTick(() => {
              const lastCard = document.querySelector('.blog-grid-dk:last-of-type a:first-of-type');
              if (lastCard) {
                  lastCard.focus();
              }
          });

      },

      sortBy: function () {

        var results = this.filtered_results.map((x) => x);

        if (this.sortDirection == "ASC") {

          results.sort((a, b) => { if (a.OriginalDate > b.OriginalDate) { return  1; } if (a.OriginalDate < b.OriginalDate) { return -1; } return 0; });

        } else {

          results.sort((a, b) => { if (a.OriginalDate < b.OriginalDate) { return  1; } if (a.OriginalDate > b.OriginalDate) { return -1; } return 0; });

        }

        this.results = results.map((x) => x);

      },

      updateSortBy(event) {

        this.sortDirection = (event.target.options[event.target.selectedIndex].label == "Ascending") ? "ASC" : "DESC";
        this.filterAndSort();

      },

    }
  };

</script>
